
// V1
import phoria from "./v1/src/phoria/phoria.score.vue";
import directional_response from "./v1/src/directional_response/directional_response.score.vue";
import motion_detection from "./v1/src/motion_detection/motion_detection.score.vue";
import randot_jump from "./v1/src/randot_jump/randot_jump.score.vue";
import randotin from "./v1/src/randotin/randotin.score.vue";
import react from "./v1/src/react/react.score.vue";

// V2
import vergence from "./v2/src/vergence/vergence.score.vue";
import bubble_pop from "./v2/src/bubble_pop/bubble_pop.score.vue";

export default {
  directional_response: directional_response,
  associated_phoria: phoria, // use phoria
  motion_detection,
  phoria,
  randot_jump,
  randotin,
  randotout: randotin,
  randotin_jump: randotin,
  randotout_jump: randotin,
  randot_vertical: randotin,
  randot_vertical_jump: randotin,
  react,
  bubble_pop,
  vergence,
  vergence_in: randotin,
  vergence_out: randotin,
  vergence_vertical: randotin,
  vergence_jump_in: randotin,
  vergence_jump_out: randotin,
  vergence_jump_inout: randot_jump,
  vergence_jump_vertical: randotin,
};
